<div>
  <div class="dashboard-container">
    <div class="content-header mb-4">
      <app-breadcrumb Titulo="Dashboard"></app-breadcrumb>
    </div>

    <!-- Top Summary Cards -->
    <div class="row">
      <div class="col-md-3">
        <div class="summary-card">
          <div class="summary-info">
            <span class="label">Minhas tarefas</span>
            <span class="value">{{ dashboard.totalTarefas }}</span>
            <span class="sub-label">{{ dashboard.totalTarefasAndamento }} em andamento</span>
          </div>
          <div class="icon-wrapper blue">
            <i class="fa fa-file-text-o"></i>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="summary-card">
          <div class="summary-info">
            <span class="label">Os meus casos</span>
            <span class="value">{{ dashboard.totalProcessos }}</span>
          </div>
          <div class="icon-wrapper green">
            <i class="fa fa-balance-scale"></i>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="summary-card">
          <div class="summary-info">
            <span class="label">Próximas audiências</span>
            <span class="value">{{ dashboard.audiencias.length }}</span>
          </div>
          <div class="icon-wrapper purple">
            <i class="fa fa-gavel"></i>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="summary-card">
          <div class="summary-info">
            <span class="label">Atendimentos para hoje</span>
            <span class="value">{{dashboard.totalAtendimentosHoje}}</span>
          </div>
          <div class="icon-wrapper cyan">
            <i class="fa fa-calendar-check-o"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content Row -->
    <div class="row mt-2">
      <!-- Priority Tasks -->
      <div class="col-md-4">
        <div class="main-card">
          <div class="card-header-custom">
            <h3 class="card-title-custom"><i class="fa fa-bullseye"></i> Tarefas</h3>
            <span class="badge-count">{{ dashboard.tarefas.length }}</span>
          </div>
          <div class="list-container">
            <div *ngIf="dashboard.tarefas && dashboard.tarefas.length > 0">
              <a *ngFor="let tarefa of dashboard.tarefas" class="list-item-custom text-decoration-none text-reset" [routerLink]="['/juridico/tarefa']" [queryParams]="{ detalheId: tarefa.id }" title="Abrir detalhes da tarefa">
                <div [class]="obterClasseIconeTarefa(tarefa.dataEntrega)">
                  <i class="fa fa-check-circle-o"></i>
                </div>
                <div class="item-content">
                  <span class="item-title">{{ tarefa.descricao }}</span>
                  <span class="item-subtitle">Prazo: {{ formatarDataEntrega(tarefa.dataEntrega) }}</span>
                </div>

                <span *ngIf="tarefa.tipo == null || tarefa.tipo == ''" class="badge-count">Comum</span>
                <span *ngIf="tarefa.tipo != null && tarefa.tipo != ''" class="badge-count">{{ tarefa.tipo }}</span>
              </a>
            </div>
            <div *ngIf="!dashboard.tarefas || dashboard.tarefas.length === 0" class="text-center text-muted py-4">
              Sem tarefas
            </div>
          </div>
        </div>
      </div>

      <!-- Upcoming Hearings -->
      <div class="col-md-4">
        <div class="main-card">
          <div class="card-header-custom">
            <h3 class="card-title-custom"><i class="fa fa-key"></i> Próximas audiências</h3>
            <span class="badge-count">{{ dashboard.audiencias.length }}</span>
          </div>
          <div class="list-container">
            <div *ngIf="dashboard.audiencias && dashboard.audiencias.length > 0">
              <a *ngFor="let aud of dashboard.audiencias" class="list-item-custom text-decoration-none text-reset" [routerLink]="['/juridico/audiencia']" [queryParams]="{ detalheId: aud.id }" title="Abrir detalhes da audiência">
                <div class="item-icon purple-light">
                  <i class="fa fa-calendar-o"></i>
                </div>
                <div class="item-content">
                  <span class="item-title">{{ aud.caso }}</span>
                  <span class="item-subtitle">{{ aud.data | date:'dd/MM/yyyy' }} at {{ aud.data | date:'HH:mm' }}</span>
                </div>
              </a>
            </div>
            <div *ngIf="!dashboard.audiencias || dashboard.audiencias.length === 0" class="text-center text-muted py-4">
              Sem audiências agendadas
            </div>
          </div>
        </div>
      </div>

      <!-- Performance -->
      <div class="col-md-4">
        <div class="main-card">
          <div class="card-header-custom">
            <h3 class="card-title-custom"><i class="fa fa-bar-chart"></i> Atendimentos</h3>
          </div>
          <div class="performance-metrics">
          <div class="metric-item">
              <a class="time-entry text-decoration-none text-reset" *ngFor="let atendimento of dashboard.atendimentos" [routerLink]="['/cadastro/atendimento']" [queryParams]="{ detalheId: atendimento.id }" title="Abrir detalhes do atendimento">
                <div class="entry-details">
                  <span class="entry-title">{{ removerTagsHtml(atendimento.titulo) }}</span>
                  <span class="entry-meta">{{ atendimento.data  | date:'dd/MM/yyyy' }} • {{ removerTagsHtml(atendimento.descricao).substring(0,30) }}...</span>
                </div>
                <span class="entry-duration">{{ obterDescricaoStatus(atendimento.status) }}</span>
              </a>
              <div *ngIf="!dashboard.atendimentos || dashboard.atendimentos.length === 0" class="text-center text-muted py-4">
                Sem atendimentos agendados
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lower Section Row -->
    <div class="row mt-2">
      <!-- Recent Time Entries -->
      <div class="col-md-8">
        <div class="main-card">
          <div class="card-header-custom">
            <h3 class="card-title-custom"><i class="fa fa-balance-scale"></i> Processos/Casos</h3>
          </div>
          <div *ngIf="!dashboard.processos || dashboard.processos.length === 0" class="text-center text-muted py-4">
            Sem processos/casos
          </div>
        <div class="time-entries" *ngIf="dashboard.processos && dashboard.processos.length > 0">
            <a class="time-entry text-decoration-none text-reset" *ngFor="let processo of dashboard.processos" [routerLink]="['/juridico/processo/detalhes', processo.id ]" title="Abrir detalhes do processo">
              <div class="entry-details">
                <span class="entry-title">{{ processo.titulo }}</span>
                <span class="entry-meta">{{ processo.ultimaMovimentacao | date:'dd/MM/yyyy' }} • {{ processo.cliente }} #{{ processo.id }}</span>
              </div>
              <span class="entry-duration">{{ obterDescricaoStatusProcesso(processo.status) }}</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Quick Actions -->
      <div class="col-md-4">
        <div class="main-card">
          <div class="card-header-custom">
            <h3 class="card-title-custom"><i class="fa fa-bullseye"></i> Ações rápidas</h3>
          </div>
          <div class="quick-actions-grid">
            <a class="action-btn" routerLink="/juridico/tarefa">
              <i class="fa fa-check-square-o"></i>
              <span>Ver tarefas</span>
            </a>
            <a class="action-btn" routerLink="/cadastro/atendimento">
              <i class="fa fa-calendar-check-o"></i>
              <span>Atendimentos</span>
            </a>
            <a class="action-btn" routerLink="/juridico/processo">
              <i class="fa fa-balance-scale"></i>
              <span>Os meus casos</span>
            </a>
            <a class="action-btn" routerLink="/empresa/financeiro">
              <i class="fa fa-money"></i>
              <span>Financeiro</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
